// extracted by mini-css-extract-plugin
export default {"name":"Name_name__8xLh6","design":"Name_design__O8nuQ","avatar":"Name_avatar__L9EYJ","resumeButton":"Name_resumeButton__07hUC","resume":"Name_resume__2KVLM"};